import { NewsSkeletonContainer } from "./styles";

export const GenericVisualSkeleton = ({ classType }) => {
  return (
    <NewsSkeletonContainer className={`${classType} visual-skeleton`}>
      <div className="picture"></div>
      <div className="mt">
        <div className="volanta"></div>
        <div className="title"></div>
        <div className="data-txt"></div>
      </div>
    </NewsSkeletonContainer>
  );
};
